export const rawColorToRGB = (colorVal) => {
    // Split colorVal into RGB values
    const noRGB = colorVal.replace("rgb(", "").replace("rgba(", "").replace(")", "");
    const result = noRGB.split(",");

    return {
        r: +result[0],
        g: +result[1],
        b: +result[2]
    };
};

export const checkBGColor = (rgbObj) => {
    const a = (0.299 * rgbObj.r + 0.587 * rgbObj.g + 0.114 * rgbObj.b) / 255;

    return {
        isLight: a > 0.5,
        borderRequired: a > 0.95
    };
};

export const applyFontContrast = (targetElement) => {
    let currentColor = targetElement.style.backgroundColor;
    if (currentColor === "" || currentColor === "transparent") {
        // if no color, let's treat it as white
        currentColor = "rgb(255, 255, 255)";
    }
    // JS backgroundColor returns RGB format
    const rgbVal = rawColorToRGB(currentColor);
    const bgColorStatus = checkBGColor(rgbVal);
    targetElement.classList.add(bgColorStatus.isLight ? "font-black" : "font-white");
    if (bgColorStatus.borderRequired) {
        targetElement.classList.add("has-border");
    }
};
